import { api } from './client'
import type { CoplayData } from '@/types'

export function fetchCoplayData(groupId: string, gameId: string): Promise<CoplayData> {
  return api.get<CoplayData>(`/groups/${groupId}/playing/${gameId}/coplay`)
}
